import { useEffect, useState } from "react";
import Mensaje from "./errorMessage";

export default function AppBlocker() {
  const [blocked, setBlocked] = useState(false);
  const [errorId, setErrorId] = useState(null);

  useEffect(() => {
    const checkBlock = (e) => {
      // Intentamos obtener el ID del evento (si existe) o directamente del localStorage
      const id = e?.detail ?? localStorage.getItem("errId");
      
      if (id && id !== "0") {
        setBlocked(true);
        setErrorId(id);
      } else {
        setBlocked(false);
        setErrorId(null);
      }
    };

    checkBlock();

    window.addEventListener("auth-error", checkBlock);

    window.addEventListener("storage", (e) => {
      if (e.key === "errId") checkBlock();
    });

    return () => {
      window.removeEventListener("auth-error", checkBlock);
      window.removeEventListener("storage", checkBlock);
    };
  }, []);

  if (!blocked) return null;
  return (
    <div 
      className="position-fixed top-0 start-0 w-100 vh-100 d-flex align-items-center justify-content-center bg-white" 
      style={{ zIndex: 9999 }}
    >
      <div className="container" style={{ maxWidth: '500px' }}>
        <div className="card border-0 text-center">
          <div className="card-body py-5">

            <div className="mb-4">
              <img 
                src="/favicon.ico" 
                alt="Logo Empresa" 
                style={{ width: '64px', height: '64px', objectFit: 'contain' }}
                className="mx-auto d-block"
              />
            </div>

            <h1 className="display-6 fw-bold text-dark mb-4">
              Acceso Restringido
            </h1>
            
            <div className="px-3 mb-5">
              <p className="text-secondary fs-5 lh-base">
                {Mensaje(errorId)}
              </p>
            </div>

            <div className="px-3 mb-5">
              <p className="text-secondary fs-6 lh-base">
                {Mensaje(`${errorId}.${errorId}`)}
              </p>
            </div>

            <hr className="w-25 mx-auto mb-5 opacity-10" />

            <div className="bg-light p-4 rounded-3">
              <p className="small fw-bold text-uppercase text-muted mb-3 tracking-wider">
                Soporte Técnico
              </p>
              <p className="mb-4 text-muted small">
                {Mensaje(`${errorId}.${errorId}.${errorId}`)}
              </p>
              <a 
                href="mailto:jose.cruz@avanzaempleo.com.co" 
                className="btn btn-dark btn-lg px-4 fs-6 fw-semibold"
              >
                jose.cruz@avanzaempleo.com.co
              </a>
            </div>

            <div className="mt-4">
              <code className="text-uppercase small text-muted opacity-50">
                Ref. ID: {errorId}
              </code>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
